export const cancellationRequests = 'cancellation-requests';
